import { call, options, params } from './helpers';

export const addComment = (payload) =>
	call(`/beta/comments`, options(payload, 'POST'));

export const deleteComment = ({ id, ...payload }) =>
	call(`/beta/comments/${id}`, options(null, 'DELETE'));

export const getComments = ({ entityType, entityId, ...payload }) =>
	call(`/beta/comments/${entityType}/${entityId}`, options(null, 'GET'));
